module.exports = __webpack_public_path__ + "media/customizations/lewiscommunities/logo-new-9377a308ac533b84761e09109778825a.png";